<!-- Contenedor principal que se adapta al sidebar -->
<div class="flex-grow w-full px-4 md:px-6 lg:px-8">
  <!-- Card contenedor fluido -->
  <div class="w-full rounded-3xl shadow-xl overflow-hidden bg-[#d6ccf0]">
    
    <!-- Header del tablero -->
    <div class="bg-[#5e35b1] text-white px-8 py-4">
      <h2 class="text-xl font-bold text-white mb-1">Proyecto: {{ nombreTablero }}</h2>
      <p class="text-sm text-white mb-2" *ngIf="descripcionTablero">{{ descripcionTablero }}</p>
    </div>

    <!-- Cuerpo con listas -->
    <div class="p-6">
      <div class="flex gap-4 overflow-x-auto pb-4">
        
        <!-- Renderizar listas -->
        <app-lista *ngFor="let lista of listas" [lista]="lista" (refrescarListas)="obtenerListas()" [listasConectadas]="listasConectadas">
        </app-lista>

        <!-- Botón: Añadir otra lista -->
        <div *ngIf="!mostrarFormularioLista" (click)="mostrarFormularioLista = true"
          class="w-64 h-[130px] flex-none bg-white rounded-md p-4 border-2 border-dashed border-gray-300 text-gray-600 cursor-pointer
          hover:bg-gray-100 hover:shadow-md transform hover:scale-[1.02] transition flex flex-col items-center justify-center">
          <div class="w-8 h-8 flex items-center justify-center rounded-full bg-green-100 text-green-600 mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
            </svg>
          </div>
          <p class="text-sm font-medium text-center text-gray-500">Añadir otra lista</p>
        </div>

        <!-- FORMULARIO PARA NUEVA LISTA -->
        <div *ngIf="mostrarFormularioLista" class="w-64 bg-white rounded-md p-4 border border-gray-300">
          <input [(ngModel)]="nuevoTituloLista" placeholder="Nombre de la lista"
            class="w-full px-2 py-1 text-sm border border-gray-300 rounded mb-2 focus:outline-none focus:ring-2 focus:ring-blue-400" />
          <div class="flex justify-between">
            <button (click)="crearNuevaLista()"
              class="bg-blue-600 text-white text-sm px-3 py-1 rounded hover:bg-blue-700">
              Añadir lista
            </button>
            <button (click)="cancelarNuevaLista()" class="bg-gray-300 text-sm px-3 py-1 rounded hover:bg-gray-400">
              Cancelar
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
